"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSideState2 = exports.defaultSideState = void 0;
var Pages_1 = require("@/rendering/common/Pages");
exports.defaultSideState = {
    items: [
        {
            name: 'Personal Details',
            page: Pages_1.Pages.ACCOUNT_INFO,
            link: 'profile/accountinfo',
        },
        {
            name: 'My Documents',
            children: [
                {
                    name: 'Pending Documents',
                    page: Pages_1.Pages.PENDING_DOCUMENT,
                    link: 'mydocument/pendingdocument',
                },
                {
                    name: 'Signed Documents',
                    page: Pages_1.Pages.SIGNED_DOCUMENT,
                    link: 'mydocument/signeddocument',
                }
            ]
        },
        {
            name: 'My Property',
            children: [
                {
                    name: 'My Listings',
                    page: Pages_1.Pages.MY_LISTINGS,
                    link: 'myproperty/mylisting',
                },
                {
                    name: 'My Viewings',
                    page: Pages_1.Pages.MY_VIEWINGS,
                    link: 'myproperty/myviewing',
                }
            ]
        },
        {
            name: 'Change Password',
            page: Pages_1.Pages.CHANGE_PASSWORD,
            link: 'profile/changepassword',
            action: 'changePassword',
        },
        {
            name: 'Alerts',
            page: Pages_1.Pages.ALERT,
            link: 'profile/alerts',
        },
        {
            name: 'Saved Search',
            page: Pages_1.Pages.SAVE_SEARCH,
            link: 'profile/savedsearch',
        },
        {
            name: 'My Places',
            link: 'profile/locations',
        }
    ]
};
exports.defaultSideState2 = {
    items: [
        {
            name: 'Saved Properties',
            page: Pages_1.Pages.SAVE_PROPERTIES,
            link: 'profile/savedproperties',
        },
        {
            name: 'Saved Searches',
            page: Pages_1.Pages.SAVE_SEARCH,
            link: 'profile/savedsearches',
        },
        {
            name: 'Recently Viewed',
            page: Pages_1.Pages.RECENTLY_VIEWED,
            link: 'profile/recentlyviewed',
        },
    ]
};
